import React, { useState, Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import { Table } from 'components/common/Elements/Elements';
import { TenantsTableConf } from '../../helpers/configurates';
import TableRow from '../TableRow/TableRow';

import classes from './ChildrenTable.module.scss';

const ChildrenTable = ({ tableData }) => {
  const [row, setRow] = useState('');

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };
  const mouseLeave = () => {
    setRow('');
  };

  return (
    <Table>
      <Table.Header>
        <Table.Row withBorder={false}>
          {TenantsTableConf.map(({ field, title }, ind) => (
            <Table.HeaderCell
              key={field}
              className={classes.headerCell}
              onMouseEnter={mouseEnter}
              onMouseLeave={mouseLeave}
              r={`r${ind}`}
              title={title}
            />
          ))}
        </Table.Row>
      </Table.Header>
      {tableData && tableData.length === 0 ? (
        <Table.Body></Table.Body>
      ) : (
        tableData && (
          <Table.Body>
            {tableData.map(company => (
              <Fragment key={company.customerId}>
                <TableRow
                  company={company}
                  family={company.childs && 'parent'}
                  row={row}
                  mouseEnter={mouseEnter}
                />
                {company.childs &&
                  company.childs.map((childs, ind) => (
                    <TableRow
                      key={`${company.customerId}-${childs.customerId}`}
                      company={childs}
                      family="child"
                      noFirst={ind !== 0}
                      row={row}
                      mouseEnter={mouseEnter}
                    />
                  ))}
              </Fragment>
            ))}
          </Table.Body>
        )
      )}
    </Table>
  );
};

ChildrenTable.propTypes = {
  tableData: PropTypes.arrayOf(object)
};

export default ChildrenTable;
